import {
  QueryData,
  QueryParams,
  VolumeData,
  VolumeDataRequest,
  VolumeDataRespose,
  VolumeRequestParams,
} from './interfaces/volume_data';

class VolumeRequest implements VolumeDataRequest {
  jsonrpc: string;
  method: string;
  id: string;
  params: VolumeRequestParams;

  constructor(
    id: string,
    begin: string,
    end: string,
    interval: string,
    source: string,
    undelying: string,
    label?: string,
    tenor?: string,
    model?: string,
  ) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'cm_time_series';
    this.params = new VolumeParams(begin, end, interval, source, undelying, label, tenor, model);
  }
}
class VolumeMultipleRequest implements VolumeDataRequest {
  jsonrpc: string;
  method: string;
  id: string;
  params: VolumeParamsMultipleQueries;

  constructor(
    id: string,
    begin: string,
    end: string,
    interval: string,
    source: string,
    undelying: string,
    data: QueryData[],
    model?: string,
  ) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'cm_time_series';
    this.params = new VolumeParamsMultipleQueries(
      begin,
      end,
      interval,
      source,
      undelying,
      data,
      model,
    );
  }
}
class VolumeParamsMultipleQueries implements VolumeRequestParams {
  begin: string;
  end: string;
  interval: string;
  queries: QueryParams[];

  constructor(
    begin: string,
    end: string,
    interval: string,
    source: string,
    underlying: string,
    data: QueryData[],
    model?: string,
  ) {
    this.begin = begin;
    this.end = end;
    this.interval = interval;
    this.queries = [];

    data.forEach((d: QueryData) => {
      this.queries.push({
        source,
        underlying,
        label: d.label,
        tenor: d.tenor,
        model,
      });
    });
  }
}

class VolumeParams implements VolumeRequestParams {
  begin: string;
  end: string;
  interval: string;
  queries: QueryParams[];

  constructor(
    begin: string,
    end: string,
    interval: string,
    source: string,
    underlying: string,
    label?: string,
    tenor?: string,
    model?: string,
  ) {
    this.begin = begin;
    this.end = end;
    this.interval = interval;
    this.queries = [
      {
        source,
        underlying,
        label,
        tenor,
        model,
      },
    ];
  }
}

class VolumeResponse implements VolumeDataRespose {
  jsonrpc: string;
  id: string;
  result: CMData[];

  constructor(id: string, jsorpc: string, result: any[]) {
    this.id = id;
    this.jsonrpc = jsorpc;
    this.result = result?.map((el) => new CMData(el));
  }
}

class VolumeResponseMultiple implements VolumeDataRespose {
  jsonrpc: string;
  id: string;
  result: CMMultiple[];

  constructor(id: string, jsorpc: string, result: any[]) {
    this.id = id;
    this.jsonrpc = jsorpc;
    this.result = result?.map((el) => new CMMultiple(el));
  }
}

class CMData implements VolumeData {
  time: number;
  value: number;

  constructor(jsonData: any[]) {
    const dateStr = jsonData[0].split(' ')[0];
    const timeStr = jsonData[0].split(' ')[1];

    const date = new Date(
      Date.UTC(
        dateStr.split('-')[0],
        dateStr.split('-')[1] - 1,
        dateStr.split('-')[2],
        timeStr.split(':')[0],
        timeStr.split(':')[1],
        timeStr.split(':')[2],
      ),
    );
    this.time = date.getTime() / 1000;
    this.value = jsonData[1];
  }
}

class CMMultiple implements VolumeData {
  time: number;
  values: number[];

  constructor(jsonData: any[]) {
    const dateStr = jsonData[0].split(' ')[0];
    const timeStr = jsonData[0].split(' ')[1];

    const date = new Date(
      Date.UTC(
        dateStr.split('-')[0],
        dateStr.split('-')[1] - 1,
        dateStr.split('-')[2],
        timeStr.split(':')[0],
        timeStr.split(':')[1],
        timeStr.split(':')[2],
      ),
    );
    this.time = date.getTime() / 1000;
    this.values = jsonData;
  }
}

export { CMData, VolumeMultipleRequest, VolumeRequest, VolumeResponse, VolumeResponseMultiple };
